var React = require('react');

function ArrowFull (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 15L15.5 15L19.5 6.96429L15.5 9.53674e-07L20 7.86805e-07L24 6.96429L20 15Z","key":0}),React.createElement("rect",{"y":"5","width":"21","height":"4","key":1})]);
}

ArrowFull.defaultProps = {"width":"24","height":"15","viewBox":"0 0 24 15"};

module.exports = ArrowFull;

ArrowFull.default = ArrowFull;
